export default __webpack_public_path__ + "static/media/wallex_logo_updated.f61fe503.webp";